<template>
  <div class="button-box" :class="selfClass" :style="{width: width + 'px'}">
    <a :href="buttonInfo.link" :target="/^http./.test(buttonInfo.link) ? '_blank' : '_self'">
      <span class="text">{{ buttonInfo.text || '查看更多' }}</span>
      <slot name="icon"></slot>
    </a>
  </div>
</template>

<script>
export default {
  props: ['buttonInfo', 'selfClass', 'width']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.button-box {
  background: $primary2;
  border-radius: 4px;
  @include mobile {
    margin: 15px auto 0;
  }
  & a {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 13px 0;
    width: 100%;
    height: 100%;
    color: #fff;
    font-weight: 500;
  }
}

.button-box.normal {
  font-size: $fontSize16;
  line-height: 1;
  background: #fff;
  & a {
    color: $primary2;
  }
}
.button-box.blue {
  font-size: $fontSize16;
  line-height: 1;
  background: $primary2;
  & a {
    color: #fff;
  }
}
.button-box.transparent {
  font-size: $fontSize16;
  line-height: 1;
  background: transparent;
  & a {
    color: $primary2;
  }
}
</style>
